/**
 * User-facing error messaging.
 *
 * Raw backend/provider/JS error text must never be shown to users (e.g. an LLM
 * billing notice or an axios "Request failed with status code 500"). The backend
 * is the authoritative source of safe, user-facing messages; the frontend simply
 * displays whatever the backend returns. For unexpected client-side failures
 * (network errors, thrown JS exceptions) where there is no sanitised backend
 * message, fall back to GENERIC_ERROR_MESSAGE instead of surfacing err.message.
 */
export const GENERIC_ERROR_MESSAGE =
  'Something went wrong on our end. Please try again shortly, and contact support if the problem continues.';
